import { render, staticRenderFns } from "./QAgentContractingStaff.vue?vue&type=template&id=90c00012&scoped=true&"
import script from "./QAgentContractingStaff.vue?vue&type=script&lang=js&"
export * from "./QAgentContractingStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c00012",
  null
  
)

export default component.exports